import { Box } from '@mui/material';
import { TableTitleBox } from '../../common/components';
import StatisticsFilters from './components/StatisticsFilters';
import { useStatistics } from './hooks/useStatistics';

// Modales para cada tipo de reporte
import FeesByOrderModal from './components/modals/FeesByOrderModal';
import DeferredCouponsModal from './components/modals/DeferredCouponsModal';
import IssuedCouponsModal from './components/modals/IssuedCouponsModal';
import ScoreRankingModal from './components/modals/ScoreRankingModal';
import SalesReportModal from './components/modals/SalesReportModal';
import DebtBalancesModal from './components/modals/DebtBalancesModal';
import SubscriberReportModal from './components/modals/SubscriberReportModal';
import CouponDetailsFerModal from './components/modals/CouponDetailsFerModal';

/**
 * Componente principal de Estadísticas
 * Refactorizado para seguir la nueva arquitectura del proyecto
 */
const Statistics = () => {
  const {
    // Estado del formulario
    filters,
    loading,
    error,

    // Datos de resultado
    results,
    header,
    modalOpen,

    // Datos externos
    groups,
    legalEntities,

    // Acciones
    handleFilterChange,
    handleSubmit,
    handleCloseModal,
  } = useStatistics();

  const renderModal = () => {
    if (!modalOpen) return null;

    const modalProps = {
      open: modalOpen,
      handleClose: handleCloseModal,
      header,
      results,
      cuotaPura: filters.cuota_pura,
    };

    const modalComponents = {
      fees_by_order: FeesByOrderModal,
      deferred_coupons: DeferredCouponsModal,
      issued_coupons: IssuedCouponsModal,
      coupon_details_fer: CouponDetailsFerModal,
      score_ranking: ScoreRankingModal,
      sales: SalesReportModal,
      debt_balances: DebtBalancesModal,
      subscribers: SubscriberReportModal,
    };

    const ModalComponent = modalComponents[filters.reportType];
    return ModalComponent ? <ModalComponent {...modalProps} /> : null;
  };

  return (
    <>
      <Box>
        <TableTitleBox title="Estadísticas | Habitat 99" />

        <StatisticsFilters
          filters={filters}
          loading={loading}
          error={error}
          groups={groups}
          legalEntities={legalEntities}
          onFilterChange={handleFilterChange}
          onSubmit={handleSubmit}
        />
      </Box>

      {renderModal()}
    </>
  );
};

export default Statistics;
